import React, {useState, useEffect} from "react";

import { Box } from '@mui/material';

import useMediaQuery from '@mui/material/useMediaQuery';

import LoadingButton from '@mui/lab/LoadingButton';

import GroupIcon from '@mui/icons-material/Group';

import ClientGroupList from './ClientGroupList';

import api from '../../../api';


import '../styles.css';

export default function ResponsiveClientGroupButton({ className, parent, childObject }) {
  const isSmallScreen = useMediaQuery('(max-width: 60rem)');
  const [display, updateDisplay] = useState(false)
  const [groups, updateGroups] = useState([])
  const [ready, updateReady] = useState()

  const closeModal = () => {
    if (isMounted && ready){
      updateDisplay(false)
       window.removeEventListener('click', closeModal)
    }
    isMounted = true
  }

   if (display && ready){
    var isMounted = false
    window.addEventListener('click', closeModal)
   }

   const getGroups = async () => {
    const url = `/api/enterprises/${parent.enterpriseId}/contact_group/`
    const response = await api.get(url)
    updateGroups(response.data)
  }

  const reloadClientsAndGroups = () => {
  parent.getClients()

  }

  useEffect(()=>{
    updateReady(true)
  }, [groups])

   useEffect(()=>{
    getGroups()
    updateReady(false)
   }, [parent.getClients])


 
     
  return (
    <>
          <LoadingButton
            className="button-add-group-selected"
            component="label"
            startIcon={<GroupIcon />}
            onClick={() => updateDisplay(true)}
          >
            Segmentos

          </LoadingButton>
          <>
          {ready &&
            <Box sx={{display: display?'block':'none'}} onClick={e => {e.stopPropagation()}} className={"clientGroupDialog"}>
            <ClientGroupList 
              groups={groups}
              clients={parent.state.clients}
              enterpriseId={parent.enterpriseId}
              changeUpdate={reloadClientsAndGroups}
              parent={parent}
              childObject={childObject}
            />
            </Box>
          }
          </>

    </>
  )
}
